function renderSimpleInput (country, field, provider) {
  return (field.name === 'confirm' ? `<div class="confirm-additional-info hidden" style="margin: 20px 0px"></div><div class="field_label-text hidden">${fields_json.params.for_fields.phone_verification}<span class="phone-number"></span></div>` : '') +
    `<div class="form-group ui-form__row ${(field.rowclass) ? field.rowclass : ''} ${field.hidden ? 'hidden' : ''} columnfield_">
      <div class="ui-form__field">
        <div class="ui-dropdown-field">
          <div class="ui-input ui-dropdown-field__active ui-input_fade">
            <label class="ui-input__container">
              <div class="ui-input__column">
                <input type="${field.type}" name="${field.name}" value="${field.value ? field.value : ''}" autocomplete="new-password" autocapitalize="sentences" placeholder="${field.placeholder}" data-hj-whitelist class="ui-input__field ${field.value ? 'ui-input__field_not-empty' : ''}" data-required ${field.disabled ? 'disabled=""' : ''}>
                <span class="ui-input__label ${(field.name === 'surname_second' && (!country.is_MX) && (!country.is_UA)) ? '' : ' ui-input__label_mark_required'}">
                  <span class="ui-input__label_placeholder-text">${field.label}</span>
                  <span class="ui-input__label_placeholder-hint"></span>
                </span>
              </div>
              <div class="ui-input__additional"></div>
            </label>
          </div>
        </div>
        ${(field.name === 'email') ? ('<div id="hint" style="font-size: 13px; padding-top: 3px"></div>') : ''}
        <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">${field.error}</div>
      </div>
    </div>`
}

export { renderSimpleInput }